import { default as BonusPeriodSwitcher } from './bonus-period-switcher'

export { BonusPeriodSwitcher }



// WEBPACK FOOTER //
// ./src/app/front-face/shared/bonus-period-switcher/index.ts